import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, CardBody, Button, Card } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast } from "react-toastify";
import avatar from "../../../assets/images/nav4.svg";
import Placeholder from "../../../assets/images/Placeholder.gif";
export default function GymOwnerDetail() {
  document.title = "Gym Owner Detail | Elevated - Admin Dashboard";
  const location = useLocation();
  const navigate = useNavigate();
  const staffId = location.state?.staffId;
  const [staffData, setStaffData] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchStaff = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.staff}/${id}`);
      setStaffData(response?.data?.data);
    } catch (error) {
      console.log("Error fetching gym owner data:", error);
      toast.error("Failed to fetch gym owner details. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (staffId) fetchStaff(staffId);
  }, [staffId]);
  const handleEditStaff = (staffId, gymId) => {
    navigate(`/add-gymowner?staffId=${staffId}&gymId=${gymId}`);
  };
  if (loading == true) {
    return (
      <p className="text-center ff-sora fw-normal font-size-16">
        <div
          className="spinner-border"
          style={{
            width: "3rem",
            height: "3rem",
            color: "#3BABA6",
          }}
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </p>
    );
  }
  if (!staffData) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center vh-50">
        <img
          src={Placeholder}
          alt="No record placeholder"
          className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
        />
        <p className="text-center ff-sora font-size-16 fw-normal">
          No Record Found!
        </p>
      </div>
    );
  }
  const formatPermissionName = (permission) => {
    return permission
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <Card className="rounded-4 ms-2 me-2 mb-2" style={{ minHeight: "550px" }}>
      <CardBody>
        <Row className="">
          <Col xs="12">
            <h2 className="card-title fw-bold ff-sora font-size-20 primary-black">
              Gym Owner Detail
            </h2>
            <span className="ff-sora secondary-black fw-normal font-size-16">
              Profile Media
            </span>
          </Col>
        </Row>

        <Row className="g-0">
          <Col xs="12" className="mb-3">
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={
                  staffData?.additionalInfo?.profileImage == null
                    ? avatar
                    : `${process.env.REACT_APP_IMG_URL}${staffData?.additionalInfo?.profileImage}`
                }
                alt={`Profile`}
                className="object-fit-cover rounded-circle"
                height={160}
                width={160}
              />
            </div>
          </Col>
        </Row>
        <Row className="g-0">
          <div>
            <h6 className="fw-normal secondary-black font-size-16 mb-3 ff-sora">
              General Info
            </h6>
            <Row className="align-items-start g-0">
              <Col
                xs="5"
                className="light-black font-size-16 ff-sora fw-normal"
              >
                <p>Name</p>
                <p>Email</p>
                <p>Phone No.</p>
                <p>User Role</p>
                <p>Permissions</p>
              </Col>
              <Col
                xs="6"
                className="secondary-black font-size-16 ff-sora fw-normal"
              >
                <p>{staffData.firstName || "N/A"}</p>
                <p className="email-ellipsis">{staffData.email || "N/A"}</p>
                <p>{staffData.phoneNumber || "N/A"}</p>
                <p>{staffData.userRole || "N/A"}</p>
                <div className="d-flex flex-wrap gap-2">
                  {Object?.entries(staffData?.userPermissions || {}).map(
                    ([category, permissions]) => {
                      return Object.entries(permissions)
                        .filter(
                          ([key]) => key !== "selected" && permissions[key]
                        )
                        .slice(0, 4) // Only show the first 4
                        .map(([permissionName], permissionIndex) => (
                          <span
                            key={`${category}-${permissionIndex}`}
                            className="badge bg-light font-size-14 fw-normal ff-sora rounded-5 px-2 py-2"
                            style={{ height: "30px" }}
                          >
                            {formatPermissionName(permissionName)}
                          </span>
                        ));
                    }
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Row>

        <Row className="g-0">
          <Col xs="12" className="mt-3 text-end mb-2">
            <Button
              className="rounded-pill"
              onClick={() => handleEditStaff(staffData.id, staffData.gymId)}
            >
              Edit Gym Owner
            </Button>
          </Col>
        </Row>
      </CardBody>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "25px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </Card>
  );
}
